import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { ContentArea, ToolbarTop, AboutPage } from "../../components";

export default function AboutProgram() {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <ContentArea>
      <ToolbarTop pageTitle={t("navigation.aboutProgram")}></ToolbarTop>
      <AboutPage
        title={t("navigation.title")}
        version={t("navigation.appVersion")}
        logo={"\\eUpisiLogo.png"}
      />
    </ContentArea>
  );
}
